import { motion, AnimatePresence } from 'framer-motion';
import { Trophy, Sparkles } from 'lucide-react';
import confetti from 'canvas-confetti';

interface PurchaseSuccessProps {
  show: boolean;
  onComplete: () => void;
}

export function PurchaseSuccess({ show, onComplete }: PurchaseSuccessProps) {
  if (show) {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    });
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          onAnimationComplete={onComplete}
          className="fixed inset-0 flex items-center justify-center bg-black/50 z-50"
        >
          <motion.div
            initial={{ y: 20 }}
            animate={{ y: 0 }}
            className="bg-white p-6 rounded-xl shadow-xl text-center"
          >
            <motion.div
              animate={{ rotate: [0, 360] }}
              transition={{ duration: 1 }}
              className="inline-block mb-4"
            >
              <Trophy className="w-12 h-12 text-yellow-500" />
            </motion.div>
            <h2 className="text-2xl font-bold mb-2">Unlocked!</h2>
            <p className="text-gray-600">Your personal career path awaits</p>
            <div className="mt-4 flex justify-center space-x-2">
              <Sparkles className="w-5 h-5 text-yellow-500 animate-pulse" />
              <span className="text-sm font-medium text-primary-600">
                250 coins spent
              </span>
              <Sparkles className="w-5 h-5 text-yellow-500 animate-pulse" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
} 